<template>
  <v-container fluid class="public-dim-book">
    <v-row class="flex-grow-0" v-if="!selectedSor">
      <v-col>
        <v-select
          outlined
          hide-details
          :items="sorOptions"
          v-model="selectedSor"
          :label="$t('contract.sor')"
        ></v-select>
      </v-col>
    </v-row>
    <!--    <v-row class="flex-grow-0">-->
    <!--      <v-btn color="primary"-->
    <!--             small-->
    <!--             class="ml-4">-->
    <!--        Load History-->
    <!--      </v-btn>-->
    <!--      <v-btn color="primary"-->
    <!--             small-->
    <!--             class="ml-4">-->
    <!--        Check-->
    <!--      </v-btn>-->
    <!--      <v-btn color="primary"-->
    <!--             small-->
    <!--             class="ml-4">-->
    <!--        Save-->
    <!--      </v-btn>-->
    <!--    </v-row>-->
    <h4 class="flex-grow-0" v-if="selectedSor">{{ selectedSor.name }}</h4>
    <v-row class="d-flex flex-grow-1" v-if="selectedSor">
      <DimBookInput
        public-mode
        :sor-id="selectedSor.id"
        :sor-name="selectedSor.name"
      ></DimBookInput>
    </v-row>
  </v-container>
</template>

<script>
import { computed, ref } from "@vue/composition-api/dist/vue-composition-api";
import { ACTION_TYPES } from "@/store/types";
import { SOR_TYPE } from "@/constants";
import { onMounted } from "@vue/composition-api";
import DimBookInput from "@/components/dimbook/DimBookInput";

export default {
  name: "PublicDimBook",
  components: { DimBookInput },
  setup(props, { root }) {
    const selectedSor = ref(null);
    const sors = ref([]);
    const sorOptions = computed(() => {
      return _.reverse(_.sortBy(sors.value, "name")).map((s) => {
        return {
          text: s.name,
          value: s,
        };
      });
    });
    const getSors = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/sor/",
        params: {
          filters: {
            type: [SOR_TYPE.SOR, SOR_TYPE.CORRIGENDUM],
            action_input_finalised_at: true,
            hidden: [false],
          },
        },
      });

      if (response.body.success) {
        sors.value = response.body.sors;
      }
    };

    onMounted(() => {
      getSors();
    });

    return {
      selectedSor,
      sorOptions,
    };
  },
};
</script>

<style lang="less">
.public-dim-book {
  display: flex;
  flex-direction: column;
}
</style>
